import Icon from "../../components/Icon/Icon"
import { Club } from "../../models/club"
import { ItemMenu } from "./model"
import { navigateToClub } from "../../utils/club"

export const MenuWithoutAuth: ItemMenu[] = 
[
  {
    label: 'Buscar clubes',
    key: '/club',
    to: '/club',
    icon: 'group',
  },
  {
    label: 'Registrar',
    key: '/register',
    to: '/register',
    icon: 'register',
  },
  {
    label: 'Entrar',
    key: '/login',
    to: '/login',
    icon: 'login',
  }
]

export const MenuAuthenticated = (userId): ItemMenu[] => 
[
  {
    label: 'Perfil',
    key: '/user',
    to: `/user/${userId}`,
    icon: 'profile',
  },
  {
    label: 'Buscar Clubes',
    key: '/club',
    to: '/club',
    icon: 'lupa',
  },
  {
    label: 'Buscar Livros',
    key: '/book',
    to: '/book',
    icon: 'lupa-book',
  },
  {
    label: 'Meus Clubes',
    key: '/user/clubs',
    to: `/user/${userId}/clubs`,
    icon: 'group',
  },
  {
    label: 'Minha Estante',
    key: '/user/bookcase',
    to: `/user/${userId}/bookcase`,
    icon: 'bookcase',
  },
  {
    label: 'Minhas Votações',
    key: '/user/votes',
    to: '/user/votes',
    icon: 'votes'
  },
  {
    label: 'Meus Fóruns',
    key: '/user/forums',
    to: `/user/forums`,
    icon: 'forum'
  },
  {
    label: 'Notificações',
    key: '/notifications',
    to: `/notifications`,
    icon: 'notification',
  },
  {
    label: 'Configurações',
    key: '/user/config',
    to: '/user/config',
    icon: 'config',
  },
  {
    label: 'Sair',
    key:'/logout',
    to: '/logout',
    icon: 'logout',
  },
]

export const MenuAuthenticatedManager = (club:Club, profile): ItemMenu[] => 
[
  {
    label: 'Perfil',
    key: 'clubs',
    to: navigateToClub(club?.name, club?.id),
    icon: 'profile',
  },
  {
    label: 'Estante',
    key: navigateToClub(club?.name, club?.id, '/bookcase'),
    to: navigateToClub(club?.name, club?.id, '/bookcase'),
    icon: 'bookcase',
  },
  {
    label: 'Encontros',
    key: navigateToClub(club?.name, club?.id, '/meets'),
    to: navigateToClub(club?.name, club?.id, '/meets'),
    icon: 'calendar',
  },
  {
    label: 'Membros',
    key: navigateToClub(club?.name, club?.id, '/members/edit'),
    to: navigateToClub(club?.name, club?.id, '/members/edit'),
    icon: 'group',
  },
  {
    label: 'Votações',
    key: navigateToClub(club?.name, club?.id, '/vote'),
    to: navigateToClub(club?.name, club?.id, '/vote'),
    icon: 'votes',
  },
  {
    label: 'Fórum',
    key: navigateToClub(club?.name, club?.id, '/forum'),
    to: navigateToClub(club?.name, club?.id, '/forum'),
    icon: 'forum',
  },
  {
    label: 'Notificações',
    key: '/notifications',
    to: '/notifications',
    icon: 'notification',
  },
  profile === 'Criador' ? {
    label: 'Configurações',
    key: '/club/edit',
    to: '/club/edit',
    icon: 'config'
  } : null,
  {
    label: 'Sair',
    key:'/logout',
    to: '/logout',
    icon: 'logout',
  },
]

export const defaultSidebarState = {
  collapsed: false,
  menu: MenuWithoutAuth
}

